import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface StepperProps {
  value: string;
  unit: string;
  onDec: () => void;
  onInc: () => void;
  testId: string;
  disabledDec?: boolean;
}

const btn =
  "flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-cad/60 text-white/80 transition-colors duration-200 hover:border-safety hover:text-safety disabled:opacity-30 disabled:hover:border-cad/60 disabled:hover:text-white/80";

export function Stepper({ value, unit, onDec, onInc, testId, disabledDec }: StepperProps) {
  return (
    <div data-testid={testId} className="flex items-center gap-2 sm:gap-3">
      <motion.button type="button" data-testid={`${testId}-dec`} aria-label="Decrease" whileTap={{ scale: 0.88 }} onClick={onDec} disabled={disabledDec} className={btn}>
        <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden><path d="M2 6h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
      </motion.button>
      <div className="flex min-w-[56px] flex-col items-center leading-none sm:min-w-[84px]">
        <motion.span
          key={value}
          data-testid={`${testId}-value`}
          initial={{ opacity: 0.4, y: 3 }}
          animate={{ opacity: 1, y: 0 }}
          className={cn("font-mono text-sm tabular-nums text-white")}
        >
          {value}
        </motion.span>
        <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.18em] text-cad">{unit}</span>
      </div>
      <motion.button type="button" data-testid={`${testId}-inc`} aria-label="Increase" whileTap={{ scale: 0.88 }} onClick={onInc} className={btn}>
        <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden><path d="M2 6h8M6 2v8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
      </motion.button>
    </div>
  );
}
